import React from 'react';



type Props = {
	children: React.ReactNode,
	footer?: React.ReactNode,
};

const ConductorLoginLayout: React.FC<Props> = (props) => {
	const {
		children,
		footer,
	} = props;

	return (
		<div className="conductor-login-page">
			<div className="conductor-login-page__form-container">
				<div className="conductor-login-page__card">
					{children}
				</div>
			</div>

			{footer !== undefined && (
				<div className="conductor-login-page__footer">
					{footer}
				</div>
			)}
		</div>
	);
};



export default ConductorLoginLayout;
